/**
 * Redux Store Configuration
 * Initializes store with all reducers and middleware
 */

import { createStore, applyMiddleware, compose } from 'redux';
import { rootReducer } from './rootReducer';
import remoteDebugMiddleware, { sessionId } from './middleware/remoteDebugMiddleware';
import initConsoleEventLogger from './middleware/consoleEventLogger';

// Create store with middleware
let store;

// Check if Redux DevTools Extension is available
const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        trace: true,
        traceLimit: 25,
      })
    : compose;

// Apply middleware
const enhancer = composeEnhancers(applyMiddleware(remoteDebugMiddleware));

store = createStore(rootReducer, enhancer);

// Initialize console event logging with the same session ID
if (process.env.REACT_APP_REMOTE_DEBUG === '1') {
  initConsoleEventLogger(sessionId);
}

export default store;